/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/// <reference types="edgeclient" />
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { PageType } from 'apmui';
import edgeClient from 'apmui/plugin/edgeClient';
import { divLog } from 'apmui/util/divLog';
import { MESSAGE } from './Model';

const app = App.get();
const client = edgeClient();

app.subscribeDefault(EventTags.START, (_, store) => {
    if (store.pageType !== PageType.LOGOUT) {
        return;
    }
    const logout = store.logout;
    const errorcode = logout.config.errorcode;
    divLog('errocode=', errorcode);

    if (client.hasNotifyUser()) {
        logout.messages = logout.messages.filter((m) => m.type !== MESSAGE.NEWSESSION);
        if (errorcode != 0) {
            client.notifyUser();
        }
    }

    if (errorcode == 20 && client.hasResetSession()) {
        client.resetSession();
    }

    if (client.hasOnAuthFailure()) {
        client.onAuthFailure();
    }

    if (client.hasOnHostClose()) {
        client.onHostClose();
    }
});
